window._hmt = window._hmt || []

// const removeFirst = () => {
//   document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove()
// }

export function github () {
  // removeFirst();
  const hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?2c195274cd3511a4924527cd6dd883a2'
  // hm.id = "baidu_tj";
  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
};

export function gitee () {
  // removeFirst();
  const hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?0f288bdbb13003ca0db28bde85bee1cb'
  // hm.id = "baidu_tj";
  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
};
